export default "__VITE_ASSET__BvK0LHvl__"